module.exports = __webpack_public_path__ + "img/img_card_qingxiang.d6808cf0.png";